import { Fragment } from 'react';
import { HpSharedHeroModule } from './HpSharedHeroModule/HpSharedHeroModule';
import { HpSharedTopHeroBannerModule } from './HpSharedTopHeroBannerModule/HpSharedTopHeroBannerModule';
import { HpSharedLocationsModule } from './HpSharedLocationsModule/HpSharedLocationsModule';
import HpSharedPromoModule from './HpSharedPromoModule/HpSharedPromoModule';
import HpSharedCollectionsModule from './HpSharedCollectionsModule/HpSharedCollectionsModule';
import HpSharedEditorialModule from './HpSharedEditorialModule/HpSharedEditorialModule';
import { HpSharedShopByModule } from './HpSharedShopByModule/HpSharedShopByModule';
import { HpSharedTopHeroBannerModuleContentPlacementVariant } from './HpSharedTopHeroBannerModule/HpSharedTopHeroBannerModuleContentPlacementVariant';
import { HpSharedEditorialModuleContentPlacementVariant } from './HpSharedEditorialModule/HpSharedEditorialModuleContentPlacementVariant';
import { HpSharedFeaturedBannerModuleContentPlacementVariant } from './HpSharedFeaturedBannerModule/HpSharedFeaturedBannerModuleContentPlacementVariant';

import { type HpSharedLayout_viewer$data } from './__generated__/HpSharedLayout_viewer.graphql';

type Homepage = NonNullable<HpSharedLayout_viewer$data['homepage']>;
type User = HpSharedLayout_viewer$data['user'];
type HomepageModules = NonNullable<NonNullable<Homepage['modules']>[0]>;

type Props = {
    componentModule: HomepageModules;
    key: string;
    startingPromoIndex: number;
    viewer: HpSharedLayout_viewer$data;
    isMobile: boolean;
    useLazyLoadImages: boolean;
    moduleIndex: number;
    totalModules: number;
    user?: User;
    isClient: boolean;
    isContentPlacementsTestVariant?: boolean;
};

export const componentModuleMap: Record<string, (payload: Props) => JSX.Element | null> = {
    topHeroBanner: ({
        componentModule,
        key,
        useLazyLoadImages,
        isMobile,
        moduleIndex,
        totalModules,
        isContentPlacementsTestVariant,
    }) =>
        isContentPlacementsTestVariant ? (
            <HpSharedTopHeroBannerModuleContentPlacementVariant key={key} isMobile={isMobile} />
        ) : (
            <HpSharedTopHeroBannerModule
                key={key}
                componentModule={componentModule}
                useLazyLoadImages={useLazyLoadImages}
                moduleIndex={moduleIndex}
                totalModules={totalModules}
            />
        ),
    hero: ({ key, viewer, user, componentModule, isMobile, isClient }) => (
        <HpSharedHeroModule
            key={key}
            viewer={viewer}
            user={user}
            componentModule={componentModule}
            isMobile={isMobile}
            isClient={isClient}
        />
    ),
    collections: ({ componentModule, key, useLazyLoadImages, moduleIndex, totalModules }) => (
        <HpSharedCollectionsModule
            key={key}
            componentModule={componentModule}
            useLazyLoadImages={useLazyLoadImages}
            moduleIndex={moduleIndex}
            totalModules={totalModules}
        />
    ),
    promo: ({
        componentModule,
        startingPromoIndex,
        key,
        useLazyLoadImages,
        isMobile,
        moduleIndex,
        totalModules,
    }) => (
        <HpSharedPromoModule
            key={key}
            componentModule={componentModule}
            startingPromoIndex={startingPromoIndex}
            useLazyLoadImages={useLazyLoadImages}
            isMobile={isMobile}
            moduleIndex={moduleIndex}
            totalModules={totalModules}
        />
    ),
    editorial: ({
        componentModule,
        key,
        useLazyLoadImages,
        moduleIndex,
        totalModules,
        isContentPlacementsTestVariant,
        isMobile,
    }) =>
        isContentPlacementsTestVariant ? (
            <HpSharedEditorialModuleContentPlacementVariant key={key} isMobile={isMobile} />
        ) : (
            <HpSharedEditorialModule
                key={key}
                componentModule={componentModule}
                useLazyLoadImages={useLazyLoadImages}
                moduleIndex={moduleIndex}
                totalModules={totalModules}
            />
        ),
    shopBy: ({
        viewer,
        componentModule,
        key,
        useLazyLoadImages,
        moduleIndex,
        totalModules,
        isClient,
    }) => (
        <HpSharedShopByModule
            key={key}
            viewer={viewer}
            componentModule={componentModule}
            useLazyLoadImages={useLazyLoadImages}
            moduleIndex={moduleIndex}
            totalModules={totalModules}
            isClient={isClient}
        />
    ),
    locations: ({ key, isMobile, user, viewer, isClient, isContentPlacementsTestVariant }) => (
        <Fragment key={key}>
            <HpSharedLocationsModule
                isMobile={isMobile}
                viewer={isClient ? viewer : null}
                user={user}
            />
            {isContentPlacementsTestVariant && (
                <HpSharedFeaturedBannerModuleContentPlacementVariant isMobile={isMobile} />
            )}
        </Fragment>
    ),
};
